import BasePropertyView from 'BasePropertyView.js';
import Template from 'behaviors/properties/main/browser-window.ejs';
import undoService      from 'UndoService';
import constants from 'Constants.js';
//=====================================================================
//
// An instance of this view represents a browser window.
//
// Casey Justus, June 3, 2016 
//
//=====================================================================
const SILENT = constants.MODEL_SILENT;

class MainBrowserWindowView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]'       : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=radio]'      : 'updateAttributesRadio'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributesRadio(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal, SILENT );
        this.render();
    }

    updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        let oldVal = this.model.get(propName);

        if (oldVal.toString() !== propVal.toString()) {
            
            this.model.set( propName, propVal, SILENT );

            undoService.add({
                undo: () => {
                    this.model.set( propName, oldVal, SILENT );
                    this.render();
                },
                redo:() => {
                    this.model.set( propName, propVal, SILENT );
                    this.render();           
                }
            }, constants.UNDO_PROP_CHANGE);
        }
       
    }


    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
       
        $("input:radio[value='"+this.model.get('windowStyle')+"']").attr('checked', true);
        
        if(this.model.get('windowStyle') === 'minimal'){
            $(`input[type=text]`).prop('disabled',false);
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainBrowserWindowView;
